import React, { useState, useEffect, Fragment, useRef } from 'react';
import moment from 'moment';
import '../../CSS/Table.css';
import { Col, Tag } from 'antd';
import { connect } from 'react-redux';
import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { objectOfObject } from '../../../Mock/MockJson';
import StyledTable from '../../../../../commons/styles/table';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { columnsAdapter } from '../../../Utils/Adapter/translationAdapter';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const StackedBar = (props) => {
  const [option, setOption] = useState({});
  const [dataSource, setDataSource] = useState([]); // Initialize dataSource
  const [columns, setColumns] = useState([]); // Initialize columns
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime
      ? graphprops.refreshTime * 60000
      : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [selectionDate, selectionMonth, selectionDateRange, DeviceCode, dayMonthYear,props.translationCache]);

  const getData = async () => {
    let json = [];

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = objectOfObject;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          (graphprops &&
            (graphprops.DashboardLevelSelection === 'datePicker' ||
              graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          ((graphprops.DashboardLevelSelection === 'monthPicker' ||
            graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          ((graphprops.DashboardLevelSelection === 'dateRangePicker' ||
            graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          ((graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
            graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          ((graphprops.DashboardLevelSelection === 'deviceSelection' ||
            graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone
          });
          requestCheck.current = true;
        }
      }
    }

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      // Process the data as per your existing logic
      let dates = [];
      let values = [];
      let name = '';
      let tagnames = [];
      let seriesarray = [];
      let legendsdata = [];
      let showLabel = graphprops?.[graphprops.graph]?.showLabel || false;
      let showStack = graphprops?.[graphprops.graph]?.showStack || false;
      let viewType = graphprops?.[graphprops.graph]?.viewType || 'vertical';

      if (
        json?.query1 &&
        Array.isArray(json.query1) &&
        graphprops?.[graphprops.graph]?.table === 'yes'
      ) {
        const dataSource = json.query1;
        setDataSource(dataSource);
        let JsonValue = graphprops?.[graphprops.graph]?.columns;
        let columnsData;
        if (typeof JsonValue === 'string') {
          try {
            columnsData = JSON.parse(JsonValue);
          } catch (e) {
            console.error('Error parsing columns JSON:', JsonValue, e);
            columnsData = [];
          }
        } else if (Array.isArray(JsonValue) || typeof JsonValue === 'object') {
          columnsData = JsonValue || [];
        } else {
          columnsData = [];
        }
        const columns = columnsAdapter(columnsData, props.translationCache);
        setColumns(columns);
      }

      if (
        json?.query1 &&
        Array.isArray(json.query1) &&
        graphprops?.[graphprops.graph]?.table === 'yes'
      ) {
        const dataSource = json.query1; // Set dataSource
        setDataSource(dataSource); // Update state
        const columnsData = JSON.parse(graphprops[graphprops.graph].columns);
        const columns = columnsAdapter(columnsData, props.translationCache); // Set columns
        setColumns(columns); // Update state
      }

      json = json?.query;

      json &&
        Array.isArray(json) &&
        json.forEach((val) => {
          if (val.Name && val.Name !== name) {
            if (!tagnames.includes(val.Name)) {
              tagnames.push(val.Name);
              name = val.Description;
              legendsdata.push({
                name: val.Description,
                icon: 'roundRect',
                textStyle: {
                  color: props.theme.algorithm === "dark" ? 'white' : 'black',
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              });
            }
          }
        });

      let yAxisData = graphprops?.[graphprops.graph]?.YAxis
        ? JSON.parse(graphprops[graphprops.graph].YAxis)
        : [];
      let yaxis =
        yAxisData &&
        Array.isArray(yAxisData) &&
        yAxisData.map((value, index) => {
          return {
            splitLine: { show: true, lineStyle: { color: '#504c4c' } },
            triggerEvent: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: graphprops?.[graphprops.graph]?.colors[index] || 'white'
              }
            },
            max: value.max,
            min: value.min,
            offset: value.offset,
            interval: value.interval,
            position: value.position,
            name: value.name,
            tags: value.tags
          };
        });

      yaxis &&
        yaxis.unshift({
          splitLine: { show: true, lineStyle: { color: '#504c4c' } },
          triggerEvent: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: graphprops?.[graphprops.graph]?.Linecolor?.[0] || 'white'
            }
          },
          axisLabel: { fontSize: 15 },
          tags: []
        });

      tagnames.forEach((tagval, tagindex) => {
        values = [];
        json.forEach((jsonval) => {
          if (tagnames[0] === jsonval.Name && tagindex === 0) {
            let date = '';
            if (graphprops.monthExists === 'true' || graphprops.monthExists === true) {
              date =
                graphprops.type === 'live'
                  ? moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format('DD/MM/YYY')
                  : moment(jsonval.DateTime).tz(props.currentTimeZone).format('DD/MM/YYYY');
            } else {
              if (props.currentTab === 'today') {
                date = moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format('HH:mm');
              } else if (props.currentTab === 'month') {
                date = moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format('DD/MM');
              } else if (props.currentTab === 'year') {
                date = moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format('MMMM');
              } else {
                if (jsonval.DateTime) {
                  date = moment
                    .utc(jsonval.DateTime)
                    .tz(props.currentTimeZone)
                    .format('YYYY-MM-DD HH:mm:ss');
                }
              }
            }
            dates.push(date);
          }
          if (tagval === jsonval.Name) {
            values.push(jsonval.Value);
          }
        });

        if (yaxis.length > 1) {
          yaxis.forEach((axis, axisindex) => {
            if (axis && axis.tags && axis.tags.includes(tagval)) {
              let linetags = graphprops?.[graphprops.graph]?.tags || [];
              if (linetags.length > 0) {
                linetags.forEach((tag) => {
                  seriesarray.push({
                    name: legendsdata[tagindex].name,
                    data: values,
                    yAxisIndex: axisindex,
                    ...(showStack ? { stack: 'total' } : {}),
                    label: { show: showLabel },
                    markPoint: {
                      data: props.graphprops.minMax
                        ? [
                            { type: 'max', name: 'Max' },
                            { type: 'min', name: 'Min' }
                          ]
                        : null
                    },
                    type: legendsdata[tagindex].name !== tag ? 'bar' : 'line',
                    axisLabel: { fontSize: 15 }
                  });
                });
              } else {
                seriesarray.push({
                  name: legendsdata[tagindex].name,
                  data: values,
                  yAxisIndex: axisindex,
                  type: 'bar',
                  axisLabel: { fontSize: 15 }
                });
              }
            }
          });
        } else {
          let linetags = graphprops?.bar?.tags || [];
          if (linetags.length > 0) {
            linetags.forEach((tag) => {
              seriesarray.push({
                name: legendsdata[tagindex].name,
                data: values,
                type: legendsdata[tagindex].name !== tag ? 'bar' : 'line',
                axisLabel: { fontSize: 15 }
              });
            });
          } else {
            seriesarray.push({
              name: legendsdata[tagindex].name,
              data: values,
              type: 'bar',
              axisLabel: { fontSize: 15 }
            });
          }
        }
      });

      const option = cloneDeep(getOption()); // Assuming getOption is defined somewhere

      let series = await trendLabelTranslation(seriesarray, props.translationCache);
      if (graphprops?.[graphprops.graph]?.colors?.length > 0) {
        option.color = [...graphprops[graphprops.graph].colors];
      }
      if (viewType === 'horizontal') {
        option.xAxis = [...yaxis];
        option.yAxis.data = [...dates];
      } else {
        option.xAxis.data = [...dates];
        option.yAxis =
          Array.isArray(yaxis) && Object.keys(yaxis).length > 0 && yaxis !== null
            ? yaxis && { ...yaxis } && yaxis
            : { ...yaxis } || {};
      }
      option.series = [...series];
      option.legend = [...legendsdata];
      setOption(option);
      setRefreshDateTime(moment());
    }

    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  const getOption = () => {
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        left: 'center',
        itemHeight: 25,
        itemWidth: 25,
        itemGap: 10.5,
        textStyle: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black',
          fontWeight: 'bold',
          fontSize: 18
        }
      },
      xAxis: {
        type: graphprops.viewType === 'horizontal' ? 'value' : 'category',
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        },
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisTick: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisLabel: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black'
        },
        scale: true
      },
      yAxis: {
        type: graphprops.viewType === 'horizontal' ? 'category' : 'value',
        scale: true,
        min: 0,
        splitLine: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisTick: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisLabel: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black'
        }
      },
      dataZoom: {
        type: 'slider'
      },
      series: [],
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            name: graphprops.title,
            backgroundColor: props.theme.algorithm === "dark" ? 'black' : 'white',
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      }
    };
  };

  return (
    <Fragment>
      {graphprops.checked && (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      )}
      {noDataInDB || errorInAPI ? (
        noDataInDB ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : graphprops[graphprops.graph]?.table !== 'yes' ? (
        <ReactEcharts
          option={option}
          style={{ height: '80%', width: '100%' }}
          className="react_for_echarts"
        />
      ) : (
        <div style={{ padding: '10px' }}>
          <Col span={24}>
            <ReactEcharts
              option={option}
              style={{ height: '280%' }}
              className="react_for_echarts"
            />
          </Col>
          <Col span={24}>
            {graphprops[graphprops.graph]?.table === 'yes' && (
              <StyledTable
                size="small"
                dataSource={dataSource} // Use dataSource here
                columns={columns} // Use columns here
                pagination={false}
                style={{ padding: '0px 10px', marginTop: '12px' }}
                scroll={{ y: 240 }}
                bordered
              />
            )}
          </Col>
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(StackedBar);
